import React from 'react';
import { PhotoGallery } from './view/photoGallery';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'PhotoGallery', 
  itemElt: (item, cmsOption) => <PhotoGallery item={item} cmsOption={cmsOption} />
}